<div class="cm-skeleton-full-layout">
  <!-- Header Section -->
  <div class="cm-skeleton-full-layout-header">
    <div class="cm-skeleton cm-skeleton--rectangle cm-skeleton--{{ animation() }}" style="width: 200px; height: 40px; border-radius: 4px;"></div>
    <div class="cm-skeleton-full-layout-header-actions">
      <div class="cm-skeleton cm-skeleton--rectangle cm-skeleton--{{ animation() }}" style="width: 80px; height: 36px; border-radius: 4px;"></div>
      <div class="cm-skeleton cm-skeleton--rectangle cm-skeleton--{{ animation() }}" style="width: 100px; height: 36px; border-radius: 4px;"></div>
      <div class="cm-skeleton cm-skeleton--rectangle cm-skeleton--{{ animation() }}" style="width: 120px; height: 36px; border-radius: 4px;"></div>
    </div>
  </div>

  <!-- Three Column Layout -->
  <div class="cm-skeleton-full-layout-content">
    <!-- Left Sidebar -->
    <aside class="cm-skeleton-full-layout-sidebar">
      <div class="cm-skeleton-full-layout-sidebar-header">
        <div class="cm-skeleton cm-skeleton--text cm-skeleton--md cm-skeleton--{{ animation() }}" style="width: 100px;"></div>
        <div class="cm-skeleton cm-skeleton--rectangle cm-skeleton--{{ animation() }}" style="width: 32px; height: 32px; border-radius: 4px;"></div>
      </div>
      @for (item of [1, 2, 3, 4, 5, 6]; track item) {
        <div class="cm-skeleton-full-layout-sidebar-item">
          <div class="cm-skeleton cm-skeleton--rectangle cm-skeleton--{{ animation() }}" style="width: 100%; height: 60px; border-radius: 4px;"></div>
        </div>
      }
    </aside>

    <!-- Center Canvas -->
    <div class="cm-skeleton-full-layout-canvas">
      <div class="cm-skeleton-full-layout-canvas-inner">
        <!-- Form Card -->
        <div class="cm-skeleton-full-layout-card">
          <div class="cm-skeleton cm-skeleton--text cm-skeleton--lg cm-skeleton--{{ animation() }}" style="width: 180px; margin-bottom: 1rem;"></div>
          @for (item of [1, 2, 3, 4]; track item) {
            <div class="cm-skeleton-full-layout-field">
              <div class="cm-skeleton cm-skeleton--text cm-skeleton--sm cm-skeleton--{{ animation() }}" style="width: 100px; margin-bottom: 0.5rem;"></div>
              <div class="cm-skeleton cm-skeleton--rectangle cm-skeleton--{{ animation() }}" style="width: 100%; height: 48px; border-radius: 4px;"></div>
            </div>
          }
        </div>
      </div>
    </div>

    <!-- Right Sidebar -->
    <aside class="cm-skeleton-full-layout-properties">
      <div class="cm-skeleton-full-layout-properties-header">
        <div class="cm-skeleton cm-skeleton--text cm-skeleton--md cm-skeleton--{{ animation() }}" style="width: 120px;"></div>
        <div class="cm-skeleton cm-skeleton--rectangle cm-skeleton--{{ animation() }}" style="width: 32px; height: 32px; border-radius: 4px;"></div>
      </div>
      <div class="cm-skeleton-full-layout-properties-content">
        @for (item of [1, 2, 3, 4]; track item) {
          <div class="cm-skeleton-full-layout-field">
            <div class="cm-skeleton cm-skeleton--text cm-skeleton--sm cm-skeleton--{{ animation() }}" style="width: 80px; margin-bottom: 0.5rem;"></div>
            <div class="cm-skeleton cm-skeleton--rectangle cm-skeleton--{{ animation() }}" style="width: 100%; height: 40px; border-radius: 4px;"></div>
          </div>
        }
      </div>
    </aside>
  </div>
</div>
